var map = {
	"./adopt.svg": "52e5",
	"./arrow.svg": "fe1f",
	"./birthday.svg": "f2b0",
	"./charge.svg": "dcf76",
	"./close-btn.svg": "7d16",
	"./express.svg": "816b",
	"./game.svg": "104e",
	"./gift.svg": "c9dc",
	"./interact.svg": "953b",
	"./love.svg": "f9bb",
	"./new_year.svg": "093e",
	"./occupy.svg": "23cf",
	"./photo.svg": "b159",
	"./scode.svg": "5242",
	"./send_video.svg": "c024",
	"./vipmember.svg": "d8d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2581";